import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { environment } from '../../../environments/environment';
import { SharedService } from '../../../app/core/services/shared.service';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';

declare var YT: any;

@Component({
  selector: 'app-podcast-view',
  templateUrl: './podcast-view.component.html',
  styleUrls: ['./podcast-view.component.scss']
})
export class PodcastViewComponent implements OnInit {

  videoEvents: Event[] = [];
  videoId: string = 'yjTnkLXil-o?si=Rz06Sq0Bjl_qL9PG';

  player: any;
  isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) private platformId: any, public sharedService : SharedService,
  @Inject(DOCUMENT) private document: Document) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit() {
    if (this.isBrowser) {
      // Load the YouTube API only in the browser
      window['onYouTubeIframeAPIReady'] = () => this.initPlayer();

      if (!window['YT']) {
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        document.body.appendChild(tag);
      } else {
        this.initPlayer();
      }
    }
  }

  initPlayer() {
    if (this.isBrowser) {
      this.player = new YT.Player('featureVideoPlayer', {
        height: '415',
        width: '100%',
        videoId: this.videoId,
        playerVars: {
          modestbranding: 1,
          rel: 0,
          controls: 1,
        }
      });
    }
  }

  seekToTime(seconds: number) {
    if (this.player) {
      this.player.seekTo(seconds, true);
      if (isPlatformBrowser(this.platformId)) {
        this.document.documentElement.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  }


      appsUrl = environment.CMS_APPS_URL;
      signUrl = environment.WEB_URL;

      podcastDetails = {
        "category": "Collaboration",
        "title": "Become an Amy Agency – Connect with Global Clients and Win More Projects",
        "speakerDetails": {
          "name": "Alexandra Zatarain",
          "description" : "In conversation with Ravi Belani, Stanford University"
        },
        "brief": "Product-market fit is a journey. Knowing your audience and mission will help you on your way.",
        "postDetails": {
          "postedDate": "June 5, 2024",
          "duration": "50 Minutes"
        },
        "tags": ["Collaboration", "Teamwork", "Productivity"],
        "socialLinks": [
          { "platform": "LinkedIn", "url": "#" },
          { "platform": "Twitter", "url": "#" },
          { "platform": "Facebook", "url": "#" },
          { "platform": "Instagram", "url": "#" }
        ],
        "video": {
          "source": "https://sample-video-link.mp4",
          "thumbnail": "https://sample-thumbnail-link.jpg",
          "duration": "49:33"
        },
        "speakerBio": "Alexandra Zatarain is the co-founder and VP of brand and marketing of Eight Sleep, the world’s first sleep fitness company. A marketer and brand-builder, Zatarain has built the Eight Sleep brand and scaled the company's revenue from $0 to current state. Eight Sleep was named one of Fast Company’s Most Innovative Companies of 2018 and was recognized two years in a row as a TIME Best Invention of the Year. In this conversation with Stanford adjunct lecturer Ravi Belani, Zatarain digs deep into the process of finding product-market fit, using examples from Eight Sleep’s struggles and successes.",
        "videoClips": [
          {
            "title": "One Workspace for Seamless Collaboration",
            "duration": "50 Minutes",
            timeStamp: 10,
            "link": "#"
          },
          {
            "title": "Effective Communication for Remote Teams",
            "duration": "30 Minutes",
            timeStamp: 20,
            "link": "#"
          },
          {
            "title": "Finding Product-Market Fit with Innovation",
            "duration": "45 Minutes",
            timeStamp: 30,
            "link": "#"
          },
          {
            "title": "Building a Culture of Productivity",
            "duration": "20 Minutes",
            timeStamp: 40,
            "link": "#"
          },
          {
            "title": "Scaling Brands in a Competitive Market",
            "duration": "60 Minutes",
            timeStamp: 60,
            "link": "#"
          }
        ]
      }
      

      podcasts = [
        {
          "id": 1,
          "presenter": "Alexandra Zatarain",
          "title": "Become an Amy Agency – Connect with Global Clients and Win More Projects",
          "duration": "50 Minutes",
          "thumbnail": "https://images.unsplash.com/photo-1534126511673-b6899657816a",
          "videoUrl": "https://example.com/video1"
        },
        {
          "id": 2,
          "presenter": "John Doe",
          "title": "Mastering Remote Work Strategies",
          "duration": "45 Minutes",
          "thumbnail": "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2",
          "videoUrl": "https://example.com/video2"
        },
        {
          "id": 3,
          "presenter": "Jane Smith",
          "title": "Boost Your Productivity with Proven Techniques",
          "duration": "30 Minutes",
          "thumbnail": "https://images.unsplash.com/photo-1522202176988-66273c2fd55f",
          "videoUrl": "https://example.com/video3"
        },
        {
          "id": 4,
          "presenter": "Michael Brown",
          "title": "Building Effective Client Relationships",
          "duration": "40 Minutes",
          "thumbnail": "https://images.unsplash.com/photo-1534126511673-b6899657816a",
          "videoUrl": "https://example.com/video4"
        },
        {
          "id": 5,
          "presenter": "Emily Johnson",
          "title": "Breaking Barriers in Global Marketing",
          "duration": "55 Minutes",
          "thumbnail": "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2",
          "videoUrl": "https://example.com/video5"
        }
      ]
}
